const link = process.env.REACT_APP_SERVER_API_V2
const getConfirmChangePassword = () => `${link}/confirm/change-password`

export default getConfirmChangePassword;
